export function removeQueryStringFromLocation(location: Location) {
  return location.href.replace(location.search, '');
}
